import {Address} from '@wix/auto_sdk_ecom_current-cart';
import {AddressModel} from './Address.model';
import {DeliveryInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class DeliveryInfoModel {
  public address: AddressModel;

  constructor(params: DeliveryInfoModel) {
    this.address = params.address;
  }

  public static fromCartV1(address?: Address) {
    if (!address) {
      return undefined;
    }
    return new DeliveryInfoModel({address: AddressModel.fromCartV1(address)});
  }

  public static fromCartV2(deliveryInfo: DeliveryInfo): DeliveryInfoModel {
    if (!deliveryInfo) {
      return undefined;
    }
    return new DeliveryInfoModel({address: AddressModel.fromCartV2(deliveryInfo.address)});
  }
}
